import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchRewardApi, deleteRewardApi, toggleRewardPublishedStateApi } from './rewardSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function Reward() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.itemSaga.reward);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                width: '5rem',
            },
            {
                name: 'description',
                selector: (row) => row.description,
                sortable: true,
                width: '30rem',
            },
            {
                name: 'item',
                selector: (row) => row.item,
                sortable: true,
            },
            {
                name: 'rate',
                selector: (row) => row.rate,
                sortable: true,
            },
            {
                name: 'min_quantity',
                selector: (row) => row.min_quantity,
                sortable: true,
            },
            {
                name: 'max_quantity',
                selector: (row) => row.max_quantity,
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        hasDelete={false}
                        row={row}
                        thunkFunc={deleteRewardApi}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchRewardApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default Reward;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
